import { createSelector } from "reselect";
import { RootState } from "../store";

export const selectGlobalReducer = (state: RootState) => state.global;

export const selectTopUpOrgId = createSelector(
  [selectGlobalReducer],
  (reducer) => {
    return reducer.topUpOrgId;
  }
);

export const selectGlobalOrgId = createSelector(
  [selectGlobalReducer],
  (reducer) => {
    return reducer.globalOrgId;
  }
);

export const selectGlobalOrgIds = createSelector(
  [selectGlobalReducer],
  (reducer) => {
    return reducer.globalOrgIds;
  }
);

export const selectCallInitiated = createSelector(
  [selectGlobalReducer],
  (reducer) => {
    return reducer.callInitiated;
  }
);
